module.exports = "https://cdn.hellotech.com/client-assets/commitment_f9d1fa5ee74aa8c254a08b689a98f39e.jpg";